import { useMemo } from 'react';

/**
 * Custom hook to detect if a user is from the UK based on browser settings
 * @returns {boolean} True if the user is detected to be from the UK
 */
export default function useRegionDetection() {
  const isUserUK = useMemo(() => {
    try {
      // Check if browser language is English GB
      const isEnglishGB = navigator.language === 'en-GB';
      
      // Check if timezone is Europe/London
      const isLondonTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone === 'Europe/London';
      
      // User is considered from UK if both conditions are true
      return isEnglishGB && isLondonTimezone;
    } catch (error) {
      console.error('Error detecting region:', error);
      // Default to international version if detection fails
      return false;
    }
  }, []);

  return isUserUK;
}
